export default () => ({
  table: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E0E0E0',
    width: '100%',
    textAlign: 'left',
    borderCollapse: 'collapse',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  },
  tableHeader: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E0E0E0',
    paddingTop: 10,
    paddingLeft: 2,
    paddingBottom: 10,
    paddingRight: 2,
    fontWeight: 500,
    textAlign: 'center',
    fontSize: '0.8rem',
    height: 60,
    minWidth: 40,
  },
  tableHeaderFirst: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E0E0E0',
    padding: 10,
    fontWeight: 500,
    fontSize: '0.95rem',
    height: 60,
  },
  tableCell: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E0E0E0',
    paddingTop: 10,
    paddingLeft: 2,
    paddingBottom: 10,
    paddingRight: 2,
    fontSize: '0.95rem',
    textAlign: 'center',
  },
  tableCellFirst: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E0E0E0',
    padding: 10,
    fontSize: '0.95rem',
  },
});



// WEBPACK FOOTER //
// ./src/screens/private/Schedules/components/ScheduleDay.styles.js